import EventEmitter from 'eventemitter2';
import BaseTransportService from 'gw-portals-transport-js';

export default ['$http', '$q', 'httpSettings', 'gwAuthTokenService', 'gwInactivityTimerService', function ($http, $q, httpSettings, AuthTokenService, gwInactivityTimerService) {
    var ee = new EventEmitter();
    var currentRequestId = void 0;
    var serviceBaseURLs = httpSettings.serviceBaseURLs;

    var baseHeaders = {
        'Content-Type': 'application/json; charset=utf-8'
    };

    var currentLocale = null;
    var portalLanguageVariant = '';

    return {
        send: function send(xCenterType, serviceEndpoint, method, params) {
            var headers = angular.copy(baseHeaders);
            if (currentLocale) {
                headers['Accept-Language'] = '' + currentLocale + portalLanguageVariant;
            }

            var request = $q.when(AuthTokenService.accessToken).then(function (token) {
                if (token) {
                    headers.Authorization = 'Bearer ' + token;
                }
                var callStart = new Date().getTime();
                var endpoint = serviceBaseURLs[xCenterType] + serviceEndpoint;
                gwInactivityTimerService.resetInactivityTimer();
                return BaseTransportService.send(endpoint, headers, method, params).then(function (response) {
                    currentRequestId = response.id;
                    return response.result;
                }).catch(function (error) {
                    console.error(error);
                    var callTime = new Date().getTime() - callStart;
                    return $q.reject({
                        baseError: error,
                        isTimeout: error.status === 0 && callTime < httpSettings.timeout
                    });
                });
            });
            ee.emit('send', request, currentRequestId, xCenterType, serviceEndpoint, method, params);
            return request;
        },

        isSessionExpiredReason: function isSessionExpiredReason(reason) {
            return reason.isTimeout === true;
        },

        setLocale: function setLocale(loc) {
            currentLocale = loc;
        },

        setLanguageVariant: function setLanguageVariant(variant) {
            portalLanguageVariant = '_' + variant;
        },

        subscribe: function subscribe(cb) {
            ee.on('send', cb);
        },
        unsubscribe: function unsubscribe(cb) {
            ee.off('send', cb);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-transport-angular/TransportService.js
// module id = 924
// module chunks = 0